(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector('[data-cart-panel]');

      this.bindEvents();
    }

    bindEvents() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.hasAttribute('open')) {
          this.close();
        }
      });

      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('cart:close', () => this.close());
      document.addEventListener('cart:toggle', () => this.toggle());

      // Delegated click handler — keeps working after refreshCart re-renders
      // inner DOM (close buttons, qty buttons, etc.).
      this.addEventListener('click', (e) => {
        const closeBtn = e.target.closest('[data-cart-close]');
        const backdrop = e.target.closest('[data-cart-backdrop]');
        const decreaseBtn = e.target.closest('[data-decrease-qty]');
        const increaseBtn = e.target.closest('[data-increase-qty]');
        const removeBtn = e.target.closest('[data-remove-item]');

        if (closeBtn || backdrop) {
          this.close();
        } else if (decreaseBtn) {
          this.updateQuantity(decreaseBtn, -1);
        } else if (increaseBtn) {
          this.updateQuantity(increaseBtn, 1);
        } else if (removeBtn) {
          this.removeItem(removeBtn);
        }
      });
    }

    open() {
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(() => {
        this.panel.querySelector('[data-cart-close]')?.focus();
      });
    }

    close() {
      this.removeAttribute('open');
      document.body.style.overflow = '';

      document.querySelector('[data-cart-toggle]')?.focus();
    }

    toggle() {
      if (this.hasAttribute('open')) {
        this.close();
      } else {
        this.open();
      }
    }

    linkedItems(item) {
      const linkId = item.dataset.engravingLink;
      if (!linkId) return [item];
      return Array.from(this.querySelectorAll(`[data-engraving-link="${linkId}"]`));
    }

    async updateQuantity(button, change) {
      const item = button.closest('[data-cart-item]');
      const quantityEl = item.querySelector('[data-quantity]');
      const newQty = parseInt(quantityEl.textContent) + change;

      if (newQty < 1) {
        this.removeItem(button);
        return;
      }

      const items = this.linkedItems(item);
      const updates = {};
      items.forEach((el) => {
        updates[el.dataset.lineKey] = newQty;
        el.classList.add('removing');
      });

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        if (response.ok) {
          this.refreshCart();
        }
      } catch (error) {
        console.error('Error updating cart:', error);
        items.forEach((el) => el.classList.remove('removing'));
      }
    }

    async removeItem(button) {
      const item = button.closest('[data-cart-item]');
      const items = this.linkedItems(item);
      const updates = {};
      items.forEach((el) => {
        updates[el.dataset.lineKey] = 0;
        el.classList.add('removing');
      });

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        if (response.ok) {
          this.refreshCart();
        }
      } catch (error) {
        console.error('Error removing item:', error);
        items.forEach((el) => el.classList.remove('removing'));
      }
    }

    async refreshCart() {
      try {
        const response = await fetch('/?section_id=cart-drawer');
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');

        if (newDrawer) {
          const content = this.querySelector('[data-cart-content]');
          const footer = this.querySelector('footer');
          const banner = this.querySelector('[data-cart-banner]');
          const newContent = newDrawer.querySelector('[data-cart-content]');
          const newFooter = newDrawer.querySelector('footer');
          const newBanner = newDrawer.querySelector('[data-cart-banner]');

          if (newContent) content.innerHTML = newContent.innerHTML;
          if (newBanner && banner) banner.innerHTML = newBanner.innerHTML;
          if (newFooter && footer) {
            footer.outerHTML = newFooter.outerHTML;
          } else if (!newFooter && footer) {
            footer.remove();
          } else if (newFooter && !footer) {
            this.querySelector('[data-cart-panel]').appendChild(newFooter.cloneNode(true));
          }
        }

        this.updateCartCount();
      } catch (error) {
        console.error('Error refreshing cart:', error);
        window.location.reload();
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const countEl = document.querySelector('[data-cart-count]');
        if (countEl) {
          if (cart.item_count > 0) {
            countEl.textContent = cart.item_count;
            countEl.hidden = false;
          } else {
            countEl.hidden = true;
          }
        }
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-selector"] && !Shopify.designMode) return;
  try {
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"]'),
        button: this.querySelector('.language-selector__button'),
        panel: this.querySelector('.language-selector__list'),
        icon: this.querySelector('.language-selector__icon')
      };

      if (!this.elements.button || !this.elements.panel) return;

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.hidden = true;
      if (this.elements.icon) {
        this.elements.icon.style.transform = '';
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector(event) {
      event.preventDefault();
      this.elements.button.focus();
      const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
      this.elements.panel.hidden = isExpanded;
      this.elements.button.setAttribute('aria-expanded', (!isExpanded).toString());
      if (this.elements.icon) {
        this.elements.icon.style.transform = isExpanded ? '' : 'rotate(180deg)';
      }
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-slideshow"] && !Shopify.designMode) return;
  try {
    class ProductCardSlideshow extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.imageCount = parseInt(this.dataset.imageCount, 10) || 1;
      this.slides = this.querySelectorAll('.product-card-slideshow__slide');
      this.dots = this.querySelectorAll('.product-card-slideshow__dot');
    }

    connectedCallback() {
      if (this.imageCount <= 1) return;

      this.setupHoverNavigation();
      this.setupDotNavigation();
    }

    setupHoverNavigation() {
      const supportsHover = window.matchMedia('(hover: hover)').matches;
      if (!supportsHover) return;

      this.addEventListener('mousemove', (e) => {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const percentage = x / rect.width;
        const newIndex = Math.floor(percentage * this.imageCount);
        const clampedIndex = Math.max(0, Math.min(newIndex, this.imageCount - 1));

        if (clampedIndex !== this.currentIndex) {
          this.goToSlide(clampedIndex);
        }
      });

      this.addEventListener('mouseleave', () => {
        this.goToSlide(0);
      });
    }

    // Touch / mobile cycling intentionally disabled — on touch devices the
    // card behaves as a single static image whose tap navigates to the
    // product detail page. Cycling stays a desktop-hover feature.

    setupDotNavigation() {
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;

      this.slides[this.currentIndex].classList.remove('is-active');
      this.slides[this.currentIndex].setAttribute('aria-hidden', 'true');

      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('is-active');
        this.dots[this.currentIndex].setAttribute('aria-selected', 'false');
      }

      this.currentIndex = index;

      this.slides[this.currentIndex].classList.add('is-active');
      this.slides[this.currentIndex].setAttribute('aria-hidden', 'false');

      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('is-active');
        this.dots[this.currentIndex].setAttribute('aria-selected', 'true');
      }
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.imageCount;
      this.goToSlide(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.imageCount) % this.imageCount;
      this.goToSlide(prevIndex);
    }
  }

  if (!customElements.get('product-card-slideshow')) {
    customElements.define('product-card-slideshow', ProductCardSlideshow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-list-renderer"] && !Shopify.designMode) return;
  try {
    class ProductCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentPage = 0;
      this.productsPerPage = parseInt(this.dataset.productsPerPage, 10) || 4;
      this.track = this.querySelector('.product-list__carousel-track');
      this.items = this.querySelectorAll('.product-list__carousel-item');
      this.prevBtn = this.querySelector('.product-list__carousel-btn--prev');
      this.nextBtn = this.querySelector('.product-list__carousel-btn--next');
      this.dotsContainer = this.querySelector('.product-list__carousel-dots');
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.swipeThreshold = 50;
    }

    connectedCallback() {
      if (this.items.length === 0) return;

      this.calculateLayout();
      this.setupNavigation();
      this.setupDots();
      this.setupTouchNavigation();
      this.setupResizeObserver();
      this.updateControls();
    }

    calculateLayout() {
      const viewportWidth = window.innerWidth;
      if (viewportWidth < 480) {
        this.visibleProducts = 1;
      } else if (viewportWidth < 768) {
        this.visibleProducts = 2;
      } else {
        this.visibleProducts = this.productsPerPage;
      }
      this.totalPages = Math.ceil(this.items.length / this.visibleProducts);
    }

    setupNavigation() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }
    }

    setupDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';
      for (let i = 0; i < this.totalPages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-list__carousel-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.setAttribute('aria-label', `Page ${i + 1}`);
        dot.addEventListener('click', () => this.goToPage(i));
        this.dotsContainer.appendChild(dot);
      }
      this.dots = this.dotsContainer.querySelectorAll('.product-list__carousel-dot');
    }

    setupTouchNavigation() {
      this.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      }, { passive: true });
    }

    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) < this.swipeThreshold) return;

      if (diff > 0) {
        this.next();
      } else {
        this.prev();
      }
    }

    setupResizeObserver() {
      const resizeObserver = new ResizeObserver(() => {
        this.calculateLayout();
        this.setupDots();
        if (this.currentPage >= this.totalPages) {
          this.currentPage = Math.max(0, this.totalPages - 1);
        }
        this.updatePosition();
        this.updateControls();
      });
      resizeObserver.observe(this);
    }

    goToPage(page) {
      if (page < 0 || page >= this.totalPages || page === this.currentPage) return;

      if (this.dots && this.dots[this.currentPage]) {
        this.dots[this.currentPage].classList.remove('is-active');
        this.dots[this.currentPage].setAttribute('aria-selected', 'false');
      }

      this.currentPage = page;

      if (this.dots && this.dots[this.currentPage]) {
        this.dots[this.currentPage].classList.add('is-active');
        this.dots[this.currentPage].setAttribute('aria-selected', 'true');
      }

      this.updatePosition();
      this.updateControls();
    }

    updatePosition() {
      const itemWidth = this.items[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this).getPropertyValue('--gap'), 10) || 0;
      const offset = this.currentPage * this.visibleProducts * (itemWidth + gap);
      this.track.style.transform = `translateX(-${offset}px)`;
    }

    updateControls() {
    }

    next() {
      if (this.currentPage < this.totalPages - 1) {
        this.goToPage(this.currentPage + 1);
      } else {
        this.goToPage(0);
      }
    }

    prev() {
      if (this.currentPage > 0) {
        this.goToPage(this.currentPage - 1);
      } else {
        this.goToPage(this.totalPages - 1);
      }
    }
  }

  if (!customElements.get('product-carousel')) {
    customElements.define('product-carousel', ProductCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
